import { format, min } from 'date-fns';

type GetFormattedEarliestDateParams = {
  dateOne: string;
  dateTwo: string;
};

export const getFormattedEarliestDate = ({ dateOne, dateTwo }: GetFormattedEarliestDateParams) => {
  return format(min([dateOne, dateTwo]), 'yyyy-MM-dd');
};
